module.exports = __webpack_public_path__ + "static/img/metaverse2.f700ad1e.png";